import { IconToggleLeftFilled, IconToggleRightFilled } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import TableComponent from '../../components/DataTable/TableComponent';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import AddIssue from './Components/AddIssue';
import EditIssueModal from './Components/EditIssueModal';

const Issues = () => {
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    const getList = async () => {
        const resp = await getApi(`${urlApi.getIssueList}?page=${activePage}&limit=${perPage}`);
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data?.items,
                totalCount: resp.data?.count
            })
        } else {
            toast.error(resp.message);
        }
    }

    useEffect(() => {
        getList()
    }, [activePage, perPage]);

    async function updateStatus(id, status) {
        loadingShow();
        let resp = await getApi(`${urlApi.updateIssueStatus}${id}/${status}`);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            getList();
        } else {
            toast.error(resp.message);
        }
    }

    const columns = [
        { name: "Sl. No", center: "true", width: "60px", selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Issue", center: "true", grow: 1.5, selector: (row) => row?.name, cell: (row) => (
                <div className='text-center'>
                    <p className='fw-bold'>{row?.issue}</p>
                </div>
            ),
        }, {
            name: "Status", center: "true", selector: (row) => row?.versionCode, cell: (row) => (<ConfirmationModal
                buttonComponent={row?.status == 1 ? <IconToggleRightFilled className='text-green-600 cursor-pointer transition-all' /> : <IconToggleLeftFilled className='text-red-700 cursor-pointer transition-all' />}
                confirmationText={`Are You Sure Want To ${row?.status == 1 ? 'Deactivate' : "Activate"} this issue ?`}
                onConfirm={() => updateStatus(row?._id, row?.status == 1 ? 2 : 1)}
            />),
        }, {
            name: "Action", center: "true", selector: (row) => row?.createdAt, cell: (row) =>
                <EditIssueModal issueData={row} callback={() => getList()} />
        },]

    return (
        <>
            <div className='flex items-center mb-3 justify-between'>
                <h1 className='text-xl font-bold text-gray-600'>Issues</h1>
                <AddIssue callback={() => getList()} />
            </div>

            <TableComponent
                columns={columns}
                data={tableData.data}
                totalRows={tableData.totalCount}
                isPagination={true}
                handlePageChange={(e) => handlePageChange(e)}
                handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />
        </>
    )
}

export default Issues